/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _call_super = require("@swc/helpers/_/_call_super");
var _class_call_check = require("@swc/helpers/_/_class_call_check");
var _create_class = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var Hook = require("./Hook");
var HookCodeFactory = require("./HookCodeFactory");
var SyncLoopHookCodeFactory = /*#__PURE__*/ function(HookCodeFactory) {
    _inherits._(SyncLoopHookCodeFactory, HookCodeFactory);
    function SyncLoopHookCodeFactory() {
        _class_call_check._(this, SyncLoopHookCodeFactory);
        return _call_super._(this, SyncLoopHookCodeFactory, arguments);
    }
    _create_class._(SyncLoopHookCodeFactory, [
        {
            key: "content",
            value: function content(param) {
                var onError = param.onError, onDone = param.onDone, rethrowIfPossible = param.rethrowIfPossible;
                return this.callTapsLooping({
                    onError: (i, err)=>onError(err),
                    onDone,
                    rethrowIfPossible
                });
            }
        }
    ]);
    return SyncLoopHookCodeFactory;
}(HookCodeFactory);
var factory = new SyncLoopHookCodeFactory();
var TAP_ASYNC = ()=>{
    throw new Error("tapAsync is not supported on a SyncLoopHook");
};
var TAP_PROMISE = ()=>{
    throw new Error("tapPromise is not supported on a SyncLoopHook");
};
function COMPILE(options) {
    factory.setup(this, options);
    return factory.create(options);
}
function SyncLoopHook() {
    var args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
    var hook = new Hook(args, name);
    hook.constructor = SyncLoopHook;
    hook.tapAsync = TAP_ASYNC;
    hook.tapPromise = TAP_PROMISE;
    hook.compile = COMPILE;
    return hook;
}
SyncLoopHook.prototype = null;
module.exports = SyncLoopHook;
